<template lang="pug">
  .Paragraph.Paragraph-margin.ParagraphPortrait

    div
      .ParagraphPortrait_image(:style="{ backgroundImage: 'url(' + item.visual + ')'}" v-if="item.visual")
      p.ParagraphPortrait_description {{ item.description }}

</template>

<script>

export default {
  props: ['item'],
  data () {
    return {}
  }
}

</script>

<style lang="stylus" scoped>

.ParagraphPortrait

  box-sizing border-box
  padding 0 20px
  max-width: 910px

  & > div

    display flex
    width 100%
    align-items center
    flex-direction column

    @media $mq_m
      flex-direction row

  @media $mq_m
    padding 0 40px

  &_image

    border-radius 50% 50% 50% 50%
    overflow hidden
    width 250px
    min-width 250px
    height 250px
    background-size cover
    background-position center center

    img

      width 100%

    @media $mq_m
      width 300px
      min-width 300px
      height 300px

  &_description

    font-size 16px
    line-height 32px
    font-weight 600
    padding 0px
    padding-top 20px

    @media $mq_m
      font-size 20px
      line-height 40px
      padding-left 80px
      padding-top 0px

    strong,
    b
      font-size 18px
      line-height 34px
      font-family: 'Sectra Display'

      @media $mq_m
        font-size 22px
        line-height 45px

</style>
